import {
    SiDiscord,
    SiGithub,
    SiPatreon,
    SiX,
    SiYoutube,
} from '@icons-pack/react-simple-icons';
import { Link } from '@tanstack/react-router';
import React from 'react';

const Footer: React.FC = () => {
    return (
        <div className="w-full p-2 text-center text-sm text-secondary-light py-4 bg-background-dark [&_a]:underline [&_a]:hover:text-primary">
            <p>&copy; 2022 - {new Date().getFullYear()} aredl.net</p>
            <p>This site is in no way affiliated with RobTop Games AB</p>
            <div className="mt-1 flex flex-wrap justify-center divide-x-2 [&_a]:px-2">
                <Link to="/terms">Terms of Service</Link>
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/guidelines">Submission Guidelines</Link>
                <a href="https://api.aredl.net/v2/docs">API Documentation</a>
            </div>
            <div className="mt-1 flex gap-2 justify-center">
                <a
                    href="https://discord.gg/aredl"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SiDiscord />
                </a>
                <a
                    href="https://github.com/All-Rated-Extreme-Demon-List"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SiGithub />
                </a>
                <a
                    href="https://www.youtube.com/@AREDLGD"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SiYoutube />
                </a>
                <a
                    href="https://x.com/AREDLgd"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SiX />
                </a>
                <a
                    href="https://patreon.com/aredl"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SiPatreon />
                </a>
            </div>
        </div>
    );
};

export default Footer;
